import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, watch, ref } from "vue";
import router from "@/router";
import AppToast from "@/utils/appToast";
import Tutorial from "@/components/Tutorial.vue";
import oonaLogo from "@/components/OonaLogo.vue";
import Sidebar from "@/components/TheSidebar.vue";
import TopBar from "./components/TheTopBar.vue";
import TheFooter from "./components/TheFooter.vue";
import checkAuth from "./utils/checkAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showTutorial = ref(false);
const tutorialClickOutside = ref(false);
const showLogo = ref(true);
const showSidebar = ref(true);
const showTopBar = ref(false);
const showFooter = ref(false);
const updateKey = ref(0);
const componentFullyLoaded = ref(false);

const componentLoaded = () => {
	// This function will be called when the component is fully loaded
	componentFullyLoaded.value = true;
};

const toggleTutorial = () => {
	showTutorial.value = !showTutorial.value;
}

const booleanStorage = (key: string): boolean => {
	return (/true/).test(localStorage.getItem(key) ?? '');
}

onMounted(() => {

	if(!localStorage.getItem('firstConnexion')){
		localStorage.setItem('firstConnexion', 'true');
	}

	const switchLogo = (state: boolean) => {
		if (state) {
			showLogo.value = true;
		} else {
			showLogo.value = false;
		}
	};

	const switchSidebar = (state: boolean) => {
		if (state) {
			showSidebar.value = true;
		} else {
			showSidebar.value = false;
		}
	};

	const switchTopBar = (state: boolean) => {
		if (state) {
			showTopBar.value = true;
		} else {
			showTopBar.value = false;
		}
	};

	const switchFooter = (state: boolean) => {
		if (state) {
			showFooter.value = true;
		} else {
			showFooter.value = false;
		}
	};

	const switchTutorial = async (name: string, state: boolean) => {
		let tutorials = [];
		if(localStorage.getItem('tutorials')){
			tutorials = JSON.parse(localStorage.getItem('tutorials')!);
		}

		if( await checkAuth() && (booleanStorage('firstConnexion') || !tutorials.includes(name)) && state ){
			showTutorial.value = true;
		} else {
			showTutorial.value = false;
		}
	}

	watch(showTutorial, () => {
		setTimeout(() => {
			tutorialClickOutside.value = !tutorialClickOutside.value;
		}, 200);
		document.body.classList.toggle('overflow-hidden');
	});

	// watch for route change
	watch(
		() => router.currentRoute.value,
		(to, from) => {
			switchLogo(to.meta.showLogo as boolean);
			switchSidebar(to.meta.showSideBar as boolean);
			switchTopBar(to.meta.showTopBar as boolean);
			switchFooter(to.meta.showFooter as boolean);
			switchTutorial(to.name as string, to.meta.tutorial as boolean);
			updateKey.value += 1;
			componentFullyLoaded.value = false;
		}
	);

	switchLogo(router.currentRoute.value.meta.showLogo as boolean);
	switchSidebar(router.currentRoute.value.meta.showSideBar as boolean);
	switchTopBar(router.currentRoute.value.meta.showTopBar as boolean);
	switchFooter(router.currentRoute.value.meta.showFooter as boolean);

	setInterval(async () => {
		await checkAuth();
	}, 60 * 1000);
});



return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (showTutorial.value)
          ? (_openBlock(), _createBlock(Tutorial, {
              key: 0,
              onToggleTutorial: _cache[0] || (_cache[0] = ($event: any) => (tutorialClickOutside.value ? toggleTutorial() : () => {}))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade-top",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (showLogo.value)
          ? (_openBlock(), _createBlock(oonaLogo, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade-left",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (showSidebar.value)
          ? (_openBlock(), _createBlock(Sidebar, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade-top",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (showTopBar.value)
          ? (_openBlock(), _createBlock(TopBar, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      id: "main-container",
      class: _normalizeClass({ 'hide-nav': !showSidebar.value })
    }, [
      _createVNode(_component_RouterView, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                onComponentLoaded: componentLoaded,
                onToggleTutorial: toggleTutorial
              }, null, 32))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (showFooter.value && componentFullyLoaded.value)
          ? (_openBlock(), _createBlock(TheFooter, { key: updateKey.value }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})